import React, { useState, useEffect } from 'react';
import { getTariffs, createTariff, updateTariff } from '../services/consumption';
import TariffModal from '../components/Consumption/TariffModal';
import './TariffsPage.css';

const TariffsPage = () => {
  const [tariffs, setTariffs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingTariff, setEditingTariff] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    max_query_limit: 0,
    extra_query_cost: 0,
    sort_order: 0,
    enabled: true
  });

  useEffect(() => {
    loadTariffs();
  }, []);

  const loadTariffs = async () => {
    try {
      setLoading(true);
      const data = await getTariffs(false);
      setTariffs(data);
    } catch (err) {
      setError('Error al cargar tarifas');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingTariff(null);
    setFormData({
      name: '',
      description: '',
      max_query_limit: 0,
      extra_query_cost: 0,
      sort_order: 0,
      enabled: true
    });
    setShowModal(true);
  };

  const handleEdit = (tariff) => {
    setEditingTariff(tariff);
    setFormData({
      name: tariff.name,
      description: tariff.description || '',
      max_query_limit: tariff.max_query_limit,
      extra_query_cost: tariff.extra_query_cost || 0,
      sort_order: tariff.sort_order || 0,
      enabled: tariff.enabled
    });
    setShowModal(true);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');

    try {
      const data = {
        name: formData.name,
        description: formData.description || null,
        max_query_limit: parseInt(formData.max_query_limit),
        extra_query_cost: parseFloat(formData.extra_query_cost) || 0,
        sort_order: parseInt(formData.sort_order) || 0,
        enabled: formData.enabled
      };

      if (editingTariff) {
        await updateTariff(editingTariff.hash, data);
      } else {
        await createTariff(data);
      }

      setShowModal(false);
      loadTariffs();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar tarifa');
    } finally {
      setLoading(false);
    }
  };

  const formatQueriesIncluded = (limit) => {
    return limit === 0 ? 'Ilimitado' : limit.toLocaleString();
  };

  const formatCost = (cost) => {
    if (!cost || cost === 0) return '-';
    return `${cost.toFixed(2)} EUR`;
  };

  return (
    <div className="tariffs-page">
      <div className="page-header">
        <h1>Tarifas</h1>
        <button onClick={handleCreate} className="btn-primary">
          + Nueva Tarifa
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="tariffs-table-container">
        {loading && !tariffs.length && <p>Cargando...</p>}
        <table className="tariffs-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripcion</th>
              <th>Analisis incluidos</th>
              <th>Coste extra</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tariffs.map((tariff) => (
              <tr key={tariff.hash}>
                <td className="tariff-name">{tariff.name}</td>
                <td className="tariff-description">{tariff.description || '-'}</td>
                <td>{formatQueriesIncluded(tariff.max_query_limit)}</td>
                <td>{formatCost(tariff.extra_query_cost)}</td>
                <td>
                  <span className={`status-badge ${tariff.enabled ? 'active' : 'inactive'}`}>
                    {tariff.enabled ? 'Activa' : 'Inactiva'}
                  </span>
                </td>
                <td className="actions">
                  <button onClick={() => handleEdit(tariff)} className="btn-edit">
                    Editar
                  </button>
                </td>
              </tr>
            ))}
            {!loading && tariffs.length === 0 && (
              <tr>
                <td colSpan={6} className="empty-message">No hay tarifas configuradas</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <TariffModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        formData={formData}
        onChange={setFormData}
        onSubmit={handleSubmit}
        isEditing={!!editingTariff}
        loading={loading}
      />
    </div>
  );
};

export default TariffsPage;
